import clsx from 'clsx';
import { useRouter } from 'next/router';
import useAssetOwner from '../hooks/useAssetOwner';
import ProfileAvatar from './ProfileAvatar';
import StyledLink from './StyledLink';
import WalletAddress from './WalletAddress';

const OwnerAddress = ({ kittyId, className }) => {
  const router = useRouter();
  const owner = useAssetOwner(kittyId, !router.pathname.includes('/profile'));

  if (!owner?.address) return null;

  return (
    <div className={clsx('flex flex-col justify-end flex-grow mt-3', className)}>
      <p className='mb-1 font-medium text-neutral-400'>Owner</p>
      <p className='font-bold text-white'>
        <StyledLink href={`/profile/${owner?.address}`} className='flex items-center'>
          {owner?.address && (
            <div className='flex items-center mr-2'>
              <ProfileAvatar width={25} address={owner?.address} />
            </div>
          )}
          <WalletAddress address={owner?.address} />
        </StyledLink>
      </p>
    </div>
  );
};

export default OwnerAddress;
